import axios from 'axios';

export const loadPrices = () =>
  axios
    .get('/api/load-price-list')
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const savePrices = values =>
  axios
    .post('/api/save-price-list', JSON.stringify(values))
    .then(response => ({ data: response.data, success: true }))
    .catch(error => ({ success: false }));



// WEBPACK FOOTER //
// ./src/modules/prices/_api.js